import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import './mapBlock.css'
import Close from '../../assets/svg/close.svg'
import Map, {Source, Layer, MapRef, MapLayerMouseEvent, Marker} from 'react-map-gl';
import {
  continentLayer,
  europeLayer,
  highlightContinentLayer,
  highlightContinentLayer2, highlightContinentLayer2Mobile, highlightContinentLayer3,
  highlightEuropeLayer, highlightEuropeLayer2, highlightEuropeLayer2Mobile
} from "../../map-styles";
import {continentsMap} from "../../maps";
import Bg from "../../assets/svg/bgContinent.svg";
import zoomBg from "../../assets/svg/zoomBg.svg";
import plusIcon from "../../assets/svg/plus.svg";
import minusIcon from "../../assets/svg/minus.svg";
import bbox from "@turf/bbox";

import europe from "../../maps/europe.json";
import asia from "../../maps/asia.json";
import america from "../../maps/north-america.json";
import africa from "../../maps/Africa.json";
import russia from "../../maps/russia.json";
import oceania from "../../maps/oceania.json";
import Pin from "./pin";
import PinActive from "./pinActive";
import PinHover from "./pinHover";
import {IContinents, ICoordinate, ICountries, IView} from "../../types/types";
import Sidebar from "../SideBar/Sidebar";
import distance from "@turf/distance";
import useWindowDimensions from "../../hooks/useWindowDimentions";


function getWindowDimensions() {
  const {innerWidth: width, innerHeight: height} = window;
  return width <= 768
}

const settings = {
  dragPan: true,
  dragRotate: false,
  scrollZoom: false,
  touchZoom: false,
  touchRotate: false,
  keyboard: false,
  doubleClickZoom: false,
}

export const continentsMaps: { [key: string]: string } = {
  europe: 'europe',
  asia: 'Asia Pacific',
  america: 'americas',
  africa: 'Middle East & Africa',
}

const continentsMapsList: { [key: string]: any } = {
  europe,
  asia,
  america,
  africa,
  // 'south america': SouthAmerica,
  russia,
  oceania

}
export const MAPBOX_TOKEN = 'pk.eyJ1Ijoia3VsaWJhYiIsImEiOiJjbDN3dWNjM2YxZGV3M21ueXh0Y3E0NjE3In0.tsEr4e71v7I3vTK1uukTbQ'; // Set your mapbox token here


const MapBlock = ({
                    zoom,
                    setZoom,
                    setContinentZoom,
                    isSidebarOpen,
                    setIsSidebarOpen,
                    hoverInfo,
                    setHoverInfo,
                    continentMap,
                    setContinentMap,
                    setCoordinate,
                    coordinate,
                    countries,
                    continents,
                    selected,
                    setSelected,
                    pinCountry,
                  }:
                    {
                      hoverInfo: any, setHoverInfo: (hoverInfo: any) => void, isSidebarOpen: boolean,
                      zoom: number,
                      setZoom: (any: any) => void,
                      continentZoom: number,
                      setContinentZoom: (any: any) => void,
                      setCoordinate: (coordinate: ICoordinate) => any,
                      setIsSidebarOpen: (isSidebarOpen: boolean) => void,
                      continentMap: null | string, setContinentMap: (continentMap: string | null) => void
                      coordinate: ICoordinate,
                      countries: ICountries[] | undefined
                      continents: IContinents[] | undefined,
                      selected: string,
                      setSelected: (any: any) => void,
                      pinCountry: ICountries[] | undefined
                    }) => {
  const mapRef = useRef<MapRef>();
  const [isMobile, setIsMobile] = useState(getWindowDimensions());
  const selectedCounty = (hoverInfo && hoverInfo.countyName) || '';
  const selectedContinent = (hoverInfo && hoverInfo.continent) || '';
  const filter = useMemo(() => ['in', 'name', selectedCounty], [selectedCounty]);
  const {height} = useWindowDimensions();

  const continentFilter = useMemo(() => ['in', 'region_un', selectedContinent], [selectedContinent]);
  const [viewState, setViewState] = useState<IView>({
    latitude: 28.52,
    longitude: 12.34,
    zoom: zoom
  });

  const currentCountryPin = countries?.find(item => item?.name === hoverInfo?.countyName);
  // useEffect(() => {
  //   if(zoom > 4) {
  //     console.log(zoom, viewState.latitude)
  //   }
  //   if(zoom < 2 && continentMap) {
  //     setContinentMap(null)
  //   }
  // }, [zoom, viewState])

  useEffect(() => {
    function handleResize() {
      setIsMobile(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const onHover = useCallback((event: any) => {
    if (isSidebarOpen) {
      return
    }

    const county = event.features && event.features[0];
    setHoverInfo({
      longitude: event.lngLat.lng,
      latitude: event.lngLat.lat,
      countyName: county && county.properties.COUNTY || county.properties.name,
      continent: county.properties?.region_un
    });
  }, [isSidebarOpen]);

  const onClickWorld = (event: MapLayerMouseEvent) => {
    const feature = event?.features?.[0];
    const formattedContinent = {
      longitude: event.lngLat.lng,
      latitude: event.lngLat.lat,
      countyName: feature && feature?.properties?.COUNTY || feature?.properties?.name,
      continent: feature?.properties?.region_un
    }
    setSelected(formattedContinent?.countyName)
    if (feature) {
      setContinentMap(feature?.properties?.region_un?.toLowerCase())
      // calculate the bounding box of the feature
      const [minLng, minLat, maxLng, maxLat] = bbox(feature);
      const paddingSize = isMobile ? 10 : 40

      mapRef?.current?.fitBounds(
        [
          [minLng, minLat],
          [maxLng, formattedContinent?.countyName === 'America' ? maxLat - 10 : maxLat]
        ],
        {
          padding: {
            top: paddingSize,
            bottom: paddingSize,
            left: paddingSize,
            right: paddingSize,
          }, duration: 1000
        }
      );


    }


  }

  const onClickCountry = (event: any) => {
    const county = event.features && event.features[0];


    const formattedCounty = {
      longitude: event.lngLat.lng,
      latitude: event.lngLat.lat,
      countyName: county && county.properties.COUNTY || county.properties.name,
      continent: county.properties?.region_un
    };

    setHoverInfo(formattedCounty);

    const currentCountryPin = countries?.find(item => item?.name === formattedCounty?.countyName);

    if (!!currentCountryPin?.offices) {
      setContinentZoom(zoom)
      setIsSidebarOpen(true)
      mapRef?.current?.flyTo({
        center: [currentCountryPin?.longitude, currentCountryPin?.latitude] as any,
        zoom: 5,
        duration: 1000,
        padding: {
          top: 0,
          bottom: 0,
          left: isMobile ? 0 : 325,
          right: 0,
        }
      })
    } else {
      setIsSidebarOpen(false)
    }
    setCoordinate(countries?.find(item => item?.name === formattedCounty?.countyName) as any)
  }

  const pinsCitiesContinent = useMemo(
    () =>
      pinCountry?.map((city, index) => (
        <Marker
          key={`marker-${index}`}

          longitude={city?.longitude as number | undefined || 0}
          latitude={city?.latitude as number | undefined || 0}
          style={{position: 'fixed', top: 0}}
          onClick={() => {
            if (continentMap) {
              onClickCountry({
                features: [continentsMapsList?.[continentMap]?.features.find((el: any) => el.properties.name === city.name)],
                lngLat: {lng: city.longitude, lat: city.latitude}
              })
            }
          }
          }
        >
          <div onMouseEnter={() => onHover({
            features: [continentsMapsList?.[continentMap || '']?.features.find((el: any) => el.properties.name === city.name)],
            lngLat: {lng: city.longitude, lat: city.latitude}
          })}
               onMouseMove={e => {
                 e.stopPropagation()
                 e.nativeEvent.stopImmediatePropagation();
               }}
               onMouseLeave={() => setHoverInfo(null)}>
            <div className={'map-marker-count'}>{city?.offices?.length}</div>
            {city?.longitude && city?.latitude ?
              city?.name === selectedCounty ? <div><PinHover/></div> : <Pin/>
              : <div></div>}
          </div>
        </Marker>

      )),
    [selectedCounty, pinCountry, selectedContinent, mapRef?.current]
  );

  const pins = useMemo(
    () =>
      continents?.map((item, index) => (
        <Marker
          key={`marker-${index}`}
          longitude={item.longitude as number | undefined || 0}
          latitude={item.latitude as number | undefined || 0}
          style={{position: 'fixed', top: 0}}
          onClick={() => {
            if (item.continent) {
              onClickWorld({
                features: [continentsMap.features.find((el: any) => el.properties.name === item.continent)],
                lngLat: {lng: item.longitude, lat: item.latitude}
              } as any)
            }
          }}

        >
          <div onMouseEnter={(e) => {
            onHover({
              features: [continentsMap.features.find((el: any) => el.properties.name === item.continent)],
              lngLat: {lng: item.longitude, lat: item.latitude}
            })
          }}
               onMouseMove={e => {
                 e.stopPropagation()
                 e.nativeEvent.stopImmediatePropagation();
               }}
               onMouseLeave={(e) => {
                 setHoverInfo(null)
               }}
          >
            {!!item?.country ? item?.continent === selectedContinent
              ? <div>
                <div><PinHover/></div>
                {item.title && <div className={'continent-marker-title'}>{item.title}</div>}
                <div
                  className={'map-marker-count map-marker-count-hover'}>{item?.country?.reduce((acc, el) => acc + (el?.offices?.length || 0), 0)}</div>
              </div>

              : <div>
                <div
                  className={'map-marker-count'}>{item?.country?.reduce((acc, el) => acc + (el?.offices?.length || 0), 0)}</div>
                <div className={'map-marker-pin'}><Pin/></div>
              </div>
              : <div></div>}
          </div>
        </Marker>

      )),
    [selectedContinent, continents]
  );

  const pinsSelected = useMemo(
    () => (
      <Marker
        longitude={coordinate?.longitude as number | undefined || 0}
        latitude={coordinate?.latitude as number | undefined || 0}
        style={{position: 'fixed', top: 0}}
      >
        <div className={'map-marker-pin-active'}>
          <div className={'map-marker-count color-light-blue'}>{coordinate?.offices?.length}</div>
          <PinActive/></div>
      </Marker>
    ),

    [coordinate]
  );

  const settings = isMobile ? {} : {
    onMouseMove: onHover,
    onMouseLeave: () => {
      if (isSidebarOpen) {
        return
      }
      setHoverInfo(null)
    },
    onMouseEnter: onHover
  }

  return (
    <>
      <Map
        //@ts-ignore
        ref={mapRef}

        {...viewState}
        {...settings}
        onMove={evt => {
          setViewState(evt.viewState)
          if (zoom > 2.5 && continentMap && !isSidebarOpen) {
            const nearest = {
              distance: 999999,
              continent: ''
            };


            continents?.forEach((el: any) => {
              let range = distance([el.latitude, el.longitude], [evt.viewState.latitude as number, evt.viewState.longitude as number])
              if (range < nearest.distance) {
                nearest.distance = range;
                nearest.continent = el.continent
              }
            })

            setContinentMap(nearest.continent.toLowerCase())
            setSelected(nearest.continent)
            // console.log(evt.viewState);
          }
        }}
        style={{height, cursor: 'pointer', overflow: 'hidden'}}
        minZoom={0}
        {...settings}

        onZoom={e => {
          setZoom(e.viewState.zoom)
        }}
        zoom={zoom}
        mapStyle="mapbox://styles/kulibab/cl3wvu2g0002i14s4qyjmd44d"
        mapboxAccessToken={MAPBOX_TOKEN}
        onDblClick={() => {
        }}
        onClick={!continentMap ? onClickWorld : onClickCountry}
        interactiveLayerIds={[continentMap ? 'my-data3' : 'my-data']}
      >

        {continentMap && <Source id={'321'} type="geojson" data={{
          type: "FeatureCollection",
          features: (continentsMapsList[continentMap] as any).features
            .filter((el: any) => countries?.some((pin) => pin.name === el.properties.name))
        }}>

            <Layer beforeId="waterway-label" {...continentLayer} />
          {/*{selectedContinent === 'Europe' && <Layer {...highlightEuropeLayer} filter={zoom < 3 ? continentFilter : filter}/>}*/}
          {/*{selectedContinent === 'Europe' && <Layer {...highlightEuropeLayer2} filter={zoom < 3 ? continentFilter: filter}/>}*/}

          {!isSidebarOpen
            ?
            <>
              {!isMobile ? <Layer {...highlightContinentLayer} filter={filter}/> :
                <Layer {...highlightContinentLayer} />}
              {!isMobile ? <Layer {...highlightContinentLayer2} filter={filter}/> :
                <Layer {...highlightContinentLayer2Mobile} />}
              {pinsCitiesContinent}
            </>
            : <>
              <Layer {...highlightContinentLayer3} filter={filter}/>
              <div className={'sidebar-border'}>
                <div className={'sidebar-white-stripe'}/>
              </div>
              {pinsSelected}
            </>
          }

        </Source>}

        {!continentMap && <Source id={'123'} type="geojson" data={{
          type: "FeatureCollection",
          features: continentsMap.features.filter((el: any) =>
            continents?.some((pin) => pin.continent === el.properties.name)) as any
        }}>
            <Layer beforeId="waterway-label" {...europeLayer} />
          {!isMobile ? <Layer {...highlightEuropeLayer} filter={continentFilter}/> :
            <Layer {...highlightEuropeLayer} />}
          {!isMobile ? <Layer {...highlightEuropeLayer2} filter={continentFilter}/> :
            <Layer {...highlightEuropeLayer2Mobile}/>}

          {pins}
        </Source>}

        <div className={'map'}>

          <div className={'map-item'}>
            <div className={'map-block-bg'}>
              <img src={Bg}/>
            </div>

            {!!continentMap ? <div className={'map-block'}>
              <div className={'map-icon-close'} onClick={() => {
                mapRef?.current?.zoomTo(1.9, {duration: 2000})
                setContinentMap(null)


              }}>
                <img src={Close} alt='close'/>
              </div>
              <div className={'map-continent'}>
                {continentsMaps[continentMap]}
              </div>
              <div className={'map-continent-separator'}/>
              <div className={'map-location footprint'}>
                Locations
              </div>
            </div> : <div className={'map-block'}>
              <div className={'map-location'} style={{justifyContent: 'center', width: '100%'}}>
                global footprint
              </div>
            </div>}
          </div>
        </div>


        <div className={'zoom-wrap'}>
          <div className={'zoom-rel-block'}>
            <div className={'zoom-bg'}>
              <img src={zoomBg}/>
            </div>

            <div className={'zoom-block'}>
              <div className={'zoom-icon'}
                   onClick={() => {
                     if (zoom > 2.5) {
                       const nearest = {
                         distance: 999999,
                         continent: ''
                       };


                       continents?.forEach((el: any) => {
                         let range = distance([el.latitude, el.longitude], [viewState.latitude as number, viewState.longitude as number])
                         if (range < nearest.distance) {
                           nearest.distance = range;
                           nearest.continent = el.continent
                         }
                       })

                       setContinentMap(nearest.continent.toLowerCase())
                       setSelected(nearest.continent)
                       // console.log(evt.viewState);
                     }
                     mapRef?.current?.zoomTo(zoom + 1, {duration: 1000})
                   }}
              >
                <img src={plusIcon} alt='close'/>
              </div>
              <div className={'zoom-separator'}/>
              <div className={'zoom-icon'}
                   onClick={() => {
                     setHoverInfo(null);
                     if (zoom < 4) {
                       setContinentMap(null)
                     }
                     mapRef?.current?.zoomTo(zoom - 1, {duration: 1000})
                   }}
              >
                <img src={minusIcon} alt='close'/>
              </div>
            </div>
          </div>
        </div>

      </Map>

      {isSidebarOpen && <div className={'sidebar-bg'} onClick={e => e.stopPropagation()}/>}
      <Sidebar isActive={isSidebarOpen} onClose={() => {
        mapRef?.current?.zoomOut({offset: [80, 60]})
        setIsSidebarOpen(false)
      }}
               country={hoverInfo?.countyName} hoverInfo={hoverInfo}
               continentMap={continentMap} isSidebarOpen={isSidebarOpen}
               coordinate={coordinate}/>
    </>
  );
};

export default MapBlock;